"use client";

import React, { forwardRef } from "react";
import styled from "styled-components";
import { tagStyles, Content } from "./sharedStyles";
import { A11y } from "@churchofjesuschrist/eden-buttons";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyActionable = styled(A11y).withConfig({
  componentId: "sc-1670anj-0"
})(["", ""], tagStyles);

/**
 * A tag is a keyword or term that is assigned to a piece of information. The `Actionable` tag will trigger an event when clicked.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The tag contents
 * @param {boolean} [props.disabled] - Whether the tag is disabled
 * @param {Function} [props.onClick] - Handler for when the tag is clicked
 * @param {string} [props.href] - The link URL. (Also changes the tag from a `<button>` to an `<a>`)
 * @param {boolean} [props.selected] - Whether the tag is in a "selected" state
 * @param {React.Ref} ref - Ref forwarded to the underlying element.
 * @returns {React.ReactElement} The `Actionable` component
 */
const ActionableComponent = ({
  children,
  disabled,
  onClick = () => {},
  href,
  selected,
  ...props
}, ref) => /*#__PURE__*/_jsx(InternalUseOnlyActionable, {
  ...(href && !disabled ? {
    as: "a",
    rel: "tag"
  } : {}),
  disabled,
  href,
  selected,
  onClick,
  ...props,
  ref: ref,
  children: /*#__PURE__*/_jsx(Content, {
    children: children
  })
});
const Actionable = /*#__PURE__*/forwardRef(ActionableComponent);
Actionable.displayName = "Actionable";
export default Actionable;